// extracted by mini-css-extract-plugin
export default {"activityTypeSelect":"ActivityHeatMapSettings_activityTypeSelect__7nFCK","activityTypeText":"ActivityHeatMapSettings_activityTypeText__zMlaO"};